export default "__VITE_ASSET__335c7d28__"